import { DEALER_MATRIX_FAIL, DEALER_MATRIX_REQUEST, DEALER_MATRIX_SUCCESS, FETCH_TAG_SUGGESTIONS_FAILURE, FETCH_TAG_SUGGESTIONS_REQUEST, FETCH_TAG_SUGGESTIONS_SUCCESS, INVENTORY_FABRICS_FAIL, INVENTORY_FABRICS_REQUEST, INVENTORY_FABRICS_SUCCESS, INVENTORY_FAIL, INVENTORY_LIFTSTYLE_FAIL, INVENTORY_LIFTSTYLE_REQUEST, INVENTORY_LIFTSTYLE_SUCCESS, INVENTORY_REQUEST, INVENTORY_SUCCESS, ORDER_SUBMIT_FAIL, ORDER_SUBMIT_REQUEST, ORDER_SUBMIT_SUCCESS, PRODUCT_TYPES_FAIL, PRODUCT_TYPES_REQUEST, PRODUCT_TYPES_SUCCESS } from "../../constants/OrderConstants";

const orderSuggestion = {
    tagOptions: [],
    loading: false,
    error: null
};

const tagReducer = (state = orderSuggestion, action) => {
    switch (action.type) {
        case FETCH_TAG_SUGGESTIONS_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_TAG_SUGGESTIONS_SUCCESS:
            return { ...state, loading: false, tagOptions: action.payload };
        case FETCH_TAG_SUGGESTIONS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default tagReducer;

const inventorbyCatState = {
    loading: false,
    inventory: [],
    error: null,
  };
  
  // Inventory Reducer
  export const inventoryReducer = (state = inventorbyCatState, action) => {
    switch (action.type) {
      case INVENTORY_REQUEST:
        return { ...state, loading: true };
      case INVENTORY_SUCCESS:
        return { loading: false, inventory: action.payload };
      case INVENTORY_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };

  //inventory Fabric Reducer
  export const inventoryFabricsReducer = (state = { fabrics: [] }, action) => {
    switch (action.type) {
      case INVENTORY_FABRICS_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case INVENTORY_FABRICS_SUCCESS:
        return {
          ...state,
          loading: false,
          fabrics: action.payload,
        };
      case INVENTORY_FABRICS_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };

  //inventory lift style Reducer
  const initialState = {
    liftStyleInventory: [],
    loading: false,
    error: null,
  };
  
  export const liftStyleInventoryReducer = (state = initialState, action) => {
    switch (action.type) {
      case INVENTORY_LIFTSTYLE_REQUEST:
        return { ...state, loading: true };
        
      case INVENTORY_LIFTSTYLE_SUCCESS:
        return { ...state, loading: false, liftStyleInventory: action.payload };
  
      case INVENTORY_LIFTSTYLE_FAIL:
        return { ...state, loading: false, error: action.payload };
        
      default:
        return state;
    }
  };

  
  export const orderSubmitReducer = (state = {}, action) => {
    switch (action.type) {
      case ORDER_SUBMIT_REQUEST:
        return { loading: true };
      case ORDER_SUBMIT_SUCCESS:
        return { loading: false, success: true, order: action.payload };
      case ORDER_SUBMIT_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  

  //matrix data state
  export const dealerMatrixReducer = (state = { dealerMatrix: [] }, action) => {
    switch (action.type) {
      case DEALER_MATRIX_REQUEST:
        return { loading: true, dealerMatrix: [] };
      case DEALER_MATRIX_SUCCESS:
        return { loading: false, dealerMatrix: action.payload };
      case DEALER_MATRIX_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };

  //product Tye 
  export const productTypesReducer = (state = { productTypes: [], loading: false, error: null }, action) => {
  switch (action.type) {
    case PRODUCT_TYPES_REQUEST:
      return { ...state, loading: true, error: null };
    case PRODUCT_TYPES_SUCCESS:
      return { ...state, loading: false, productTypes: action.payload, error: null };
    case PRODUCT_TYPES_FAIL:
      return { ...state, loading: false, error: action.payload, productTypes: [] };
    default:
      return state;
  }
};